import styled from 'styled-components';

const getBgColor = (props) => {
	const { isSmallScreen, layout, background } = props;
	if (isSmallScreen && layout === 'single') {
		return background;
	}
	if (isSmallScreen) {
		return '#ffffff';
	}
	if (layout === 'auto') {
		return background;
	}
	return 'transparent';
};

const getRestStyles = (props) => {
	const { isIe, isSmallScreen } = props;
	if (isIe) {
		return `
			position: relative;
			margin-bottom: -100px;
		`;
	}
	if (isSmallScreen) {
		return `
			position: relative;
			height: 75px;
		`;
	}
	return `
		position: fixed;
		height: 100px;
	`;
}

const HeaderWrapper = styled.div`
	background: ${(props) => getBgColor(props)};
	display: flex;
	width: 100%;
	opacity: ${({ fade }) => (fade ? '0' : '1')};
	transition: opacity 0.3s ease-in-out;
	z-index: 100;
	${(props) => getRestStyles(props)};
`;

const Logo = styled.div`
	margin-top: ${({ isSmallScreen }) => isSmallScreen ? '5px' : '20px'};
	margin-left: 5%;
	img {
		max-width: 150px;
		height: auto;
	}
	flex-grow: 1;
`;

const Links = styled.div`
	flex-grow: 3;
`;

const ButtonWrapper = styled.div`
	position: fixed;
	right: 20px;
	top: 20px;
	display: flex;
	align-items: center;
	margin: 8px 15px;
	z-index: 110;
	& > button {
		font-weight: bold;
		background-color: white;
	}
`;

export { HeaderWrapper, Logo, Links, ButtonWrapper };
